module.exports = __webpack_public_path__ + "456d213f8fdb821617d7a7e3bf4813c0.jpg";